<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { EaterType } from '$lib/EaterType.type';

  const dispatch = createEventDispatcher<{ chooseType: EaterType }>();

  const handleClick = (type: EaterType) => () => dispatch('chooseType', type);
</script>

<div class="eater-selection">
  <button
    class="eater-selection__choice eater-selection__choice--volunteer"
    on:click={handleClick(EaterType.VOLUNTEER)}
    >Meal Token<br />
    <span class="eater-selection__subtitle">Shift Volunteers</span>
  </button>
  <button
    class="eater-selection__choice eater-selection__choice--orga"
    on:click={handleClick(EaterType.ORGA)}
    >Orange Wristband<br />
    <span class="eater-selection__subtitle">EMF Team</span>
  </button>
  <button
    class="eater-selection__choice eater-selection__choice--other"
    on:click={handleClick(EaterType.OTHER)}
    >Other<br />
    <span class="eater-selection__subtitle">No Token</span>
  </button>
</div>

<style lang="scss">
  @import '../variables';

  .eater-selection {
    $root: &;

    display: flex;

    $font-size: 3.5rem;
    $flex-gutter: 3rem;
    margin: 0 auto;
    max-width: 800px;

    &__choice {
      flex: 100% 1 1;
      height: 26vh;
      font-size: $font-size;
      line-height: 1.2;
      word-wrap: break-word;
      padding: 2rem;

      border: 0;
      box-shadow:
        0 6px 0 0 rgba(180, 180, 180, 0.5),
        0 8px 6px 4px rgba(0, 0, 0, 0.3);

      &:active {
        position: relative;
        top: 6px;
        box-shadow: none;
      }

      border-radius: 0.5rem;

      margin: 0 ($flex-gutter * 0.5);

      // &:not(:last-child) {
      // 	margin-right: 10vw;
      // }

      &--volunteer {
        //background: $colour-volunteer;
        background: linear-gradient(
          135deg,
          nth($colour-volunteer, 1) 0%,
          nth($colour-volunteer, 2) 100%
        );
      }

      &--orga {
        //background: $colour-orga;
        background: linear-gradient(135deg, nth($colour-orga, 1) 0%, nth($colour-orga, 2) 100%);
        //font-size: $font-size * 0.88;
        padding-top: 1.5rem;

        #{$root}__subtitle {
          position: relative;
          top: -1rem;
        }
      }

      &--other {
        background: linear-gradient(135deg, nth($colour-other, 1) 0%, nth($colour-other, 2) 100%);
      }
    }

    &__subtitle {
      font-size: 0.6 * $font-size;
    }
  }
</style>
